import {
  createAction,
  createAsyncThunk,
  createSlice,
  current,
} from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { ISavedCartInfo } from "../interface/ICart";
import { SavedCartParamsModel } from "../model/cart";
import { HeaderParamsModel } from "../model/common";
import SavedCartService from "../service/SavedCartService";
import { RootState } from "../store/store";
import { logoutUser } from "./common";

export const resetSavedCart = createAction("savedcart/reset");

const _service = new SavedCartService();

type SliceState = {
  value: ISavedCartInfo[];
  status: string;
  apiCallCount: number;
};
const initialState = {
  value: [],
  status: COMMON_STATUS.INITIAL,
  apiCallCount: 0,
} as SliceState;

export const getSavedCartAsync = createAsyncThunk(
  "savedcart/get",
  async (params: HeaderParamsModel) => {
    const response = await _service.getSavedCartService(params);
    return response;
  }
);

export const saveSavedCartAsync = createAsyncThunk(
  "savedcart/save",
  async (params: SavedCartParamsModel) => {
    const response = await _service.saveSavedCart(params);
    return response;
  }
);

export const savedCartSlice = createSlice({
  name: "savedcart",
  initialState,
  reducers: {
    updateSavedCartsStatus: (state: SliceState, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //get
      .addCase(getSavedCartAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getSavedCartAsync.fulfilled, (state, action) => {
        state.value = action.payload;
        state.status = COMMON_STATUS.LOADED;
        state.apiCallCount = 0;
      })
      .addCase(getSavedCartAsync.rejected, (state, action) => {
        state.status = COMMON_STATUS.FAILED;
        state.apiCallCount += 1;
      })
      //save
      .addCase(saveSavedCartAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(saveSavedCartAsync.fulfilled, (state, action: any) => {
        const currenState: any = {
          ...current(state),
          value: [...current(state).value],
        };
        const detail = { ...action.meta.arg.detail };
        if (
          currenState.value.find(
            (item: ISavedCartInfo) => item.id === action.payload
          )
        ) {
          currenState.value = currenState.value.reduce(
            (saveCarts: ISavedCartInfo[], item: ISavedCartInfo) => {
              if (item.id === action.payload) {
                saveCarts.push({ ...item, ...detail });
              } else {
                saveCarts.push({ ...item });
              }

              return saveCarts;
            },
            []
          );
        } else {
          if (!currenState.value) currenState.value = [];
          detail.id = action.payload;
          currenState.value.push({ ...detail });
        }

        state.value = currenState.value;
        state.status = COMMON_STATUS.LOADED;
      })
      .addCase(saveSavedCartAsync.rejected, (state, action) => {
        state.status = COMMON_STATUS.FAILED;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetSavedCart, (n) => {
        return initialState;
      });
  },
});

export const { updateSavedCartsStatus } = savedCartSlice.actions;
export const getSavedCart = (state: RootState) => state.savedcart;
export const getSavedCartInfo = (state: RootState) => state.savedcart.value;
export const getSavedCartStatus = (state: RootState) => state.savedcart.status;
export default savedCartSlice.reducer;
